// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import DismissContainer from './DismissContainer';

// Styles
import '../styles/investments.css';
import '../styles/paginator.css';

export default class Paginator extends React.Component {
    state = {
        currentPage: 0, 
        pageLimit: 20, 
        clicked: false,
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.state) 
            this.setState(nextProps.state);  
    }

    render = () => {
        const p = this.props;
        return (<>
            <div className='paginator-container'>
                <img 
                    className='arrow-image' 
                    alt='' 
                    src="https://static.stax.ai/images/icons/multiple-previous.svg" 
                    onClick={() => p?.totalLength ? p.setLastPage(0) :p.setPage(0)}  
                />
                <img 
                    className='arrow-image'  
                    alt='' 
                    src="https://static.stax.ai/images/icons/prev-arrow.svg" 
                    onClick={() => p.setPage(p?.totalLength ? - 1 : Math.max(0, p.currentPage - 1))}  
                />
                <div>
                    <div
                        className='paginator-container-bold'
                        style={{cursor: 'pointer'}}
                        onClick={() => this.setState({clicked: !this.state.clicked})}
                    >
                        {`${p.currentPage * p.pageSize ? 
                        p.currentPage * p.pageSize 
                        : p.items?.length ? 1 
                        : 0} - 
                        ${p?.totalLength ? 
                            (p.currentPage * p.pageSize) + p.pageSize <= p?.totalLength ? 
                        (p.currentPage * p.pageSize) + p.pageSize : 
                        p?.totalLength 
                        : (p.currentPage * p.pageSize) + p.pageSize <= p.items?.length ? 
                        (p.currentPage * p.pageSize) + p.pageSize : 
                        p.items?.length}`}

                    </div>
                    {this.state.clicked ? 
                        <DismissContainer
                            onClose={() => this.setState({clicked: false})}
                        >
                            <div
                                className='contextmenu-menu contextmenu-menu-opened'
                                style={{
                                    position: 'absolute',
                                    ...(p.bottom ? {bottom: '100%', marginBottom: 30} : {}),
                                }}
                            >
                            {(p.bottom ? p.totalLength ? [20,50,100,250].reverse() : [20,50,100,250,p.items?.length].reverse() : p.totalLength ? [20,50,100,250] : [20,50,100,250,p.items?.length]).map((option, i) => {
                                return (
                                    <div
                                        className='contextmenu-option'
                                        onClick={() => {
                                            this.setState({clicked: false});
                                            p.setPageLimit(option); 
                                        }}
                                    >
                                        {option}
                                    </div>
                                )
                            })}
                        </div>
                        </DismissContainer>
                        
                    : ""}
                        
                </div>
                <div> {`of`} </div>
                <div className='paginator-container-bold'>{p?.totalLength ? p.totalLength : p.items?.length}</div>
                <img 
                    className='arrow-image'  
                    alt='' 
                    src="https://static.stax.ai/images/icons/next-arrow.svg" 
                    onClick={() => p.setPage(p?.totalLength ? + 1 :Math.min(Math.floor(p?.items?.length / p.pageSize), p.currentPage + 1))}
                />
                <img 
                    className='arrow-image'  
                    alt='' 
                    src="https://static.stax.ai/images/icons/multiple-next.svg" 
                    onClick={() => {
                        p?.totalLength ? p.setLastPage(Math.floor(p.totalLength/p.pageSize)) : p.setPage(Math.floor(p?.items?.length / p.pageSize))} 
                    }
                />
            </div>
        </>)
    }
}